import React, { useRef } from 'react';

import cn from 'classnames';

import { formatPrice } from '@shared/helpers';
import { useIsOverflowing } from '@shared/hooks';
import { IEstimate } from '@widgets/EstimateInformation/model/types/types';

import cls from './MultiEstimateLink.module.css';

interface MultiEstimateLinkProps {
    isShowAllEstimates?: boolean;
    estimates: IEstimate[];
    hiddenCount: number;
}

export const MultiEstimateLink = ({
    isShowAllEstimates,
    estimates,
    hiddenCount,
}: MultiEstimateLinkProps) => {
    const estimateRef = useRef<HTMLDivElement | null>(null);

    const elWithTitleIndex = estimates.length - hiddenCount - 1;

    const { isOverflowing } = useIsOverflowing({ elRef: estimateRef });

    return (
        <div
            ref={estimateRef}
            className={cn(cls.estimatesEllipsis, isShowAllEstimates && cls.showAllEstimates)}
        >
            {estimates.length > 0 &&
                estimates.map((estimate, index) => (
                    <a
                        title={
                            isOverflowing && index === elWithTitleIndex
                                ? `${estimate.name}. ${formatPrice(+estimate.cost, {
                                      maximumFractionDigits: 2,
                                      minimumFractionDigits: 0,
                                      withCurrency: false,
                                  })} ${estimate.currencySign}`
                                : undefined
                        }
                        key={estimate.url}
                        href={estimate.url}
                        className={cn(cls.estimateLink, isShowAllEstimates && cls.showAllEstimates)}
                    >
                        {estimate.name}.{' '}
                        {formatPrice(+estimate.cost, {
                            maximumFractionDigits: 2,
                            minimumFractionDigits: 0,
                            withCurrency: false,
                        })}{' '}
                        {estimate.currencySign}
                    </a>
                ))}
        </div>
    );
};
